import step_1 from "../../../../assets/images/step-1.png";
import step_2 from "../../../../assets/images/step-2.png";
import step_3 from "../../../../assets/images/step-3.png";
import step_4 from "../../../../assets/images/step-4.png";
import step_5 from "../../../../assets/images/step-5.png";

import solar_step_0 from "../../../../assets/images/solar-step-1.png";
import solar_step_1 from "../../../../assets/images/solar-step-2.png";
import solar_step_2 from "../../../../assets/images/solar-step-3.png";
import solar_step_3 from "../../../../assets/images/solar-step-4.png";
import solar_step_4 from "../../../../assets/images/solar-step-5.png";
import solar_step_5 from "../../../../assets/images/solar-step-6.png";

import mob_step_1 from "../../../../assets/images/mob-step-1.png";
import mob_step_2 from "../../../../assets/images/mob-step-2.png";
import mob_step_3 from "../../../../assets/images/mob-step-3.png";
import mob_step_4 from "../../../../assets/images/mob-step-4.png";
import mob_step_5 from "../../../../assets/images/mob-step-5.png";

import mob_solar_step_0 from "../../../../assets/images/mob-solar-step-1.png";
import mob_solar_step_1 from "../../../../assets/images/mob-solar-step-2.png";
import mob_solar_step_2 from "../../../../assets/images/mob-solar-step-3.png";
import mob_solar_step_3 from "../../../../assets/images/mob-solar-step-4.png";
import mob_solar_step_4 from "../../../../assets/images/mob-solar-step-5.png";
import mob_solar_step_5 from "../../../../assets/images/mob-solar-step-6.png";

export const STEPS = {
  SOLAR: {
    mobile: {
      0: mob_solar_step_0,
      1: mob_solar_step_1,
      2: mob_solar_step_2,
      3: mob_solar_step_3,
      4: mob_solar_step_4,
      5: mob_solar_step_5,
    },
    desktop: {
      0: solar_step_0,
      1: solar_step_1,
      2: solar_step_2,
      3: solar_step_3,
      4: solar_step_4,
      5: solar_step_5,
    },
  },

  REST: {
    mobile: {
      0: mob_step_1,
      1: mob_step_2,
      2: mob_step_3,
      3: mob_step_4,
      4: mob_step_5,
      5: mob_step_5,
    },
    desktop: {
      0: step_1,
      1: step_2,
      2: step_3,
      3: step_4,
      4: step_5,
      5: step_5,
    },
  },
};
